// Whether the game bar's blunder count fits beside the title (2026-10-12).
// The bar is one row: back · title (ellipsises) · ending chip … count ·
// More · link. The user wants the count to go before the title is cut, so
// the bar measures the natural widths of its parts (the title's scrollWidth,
// which is its whole text even while it is clipped) and hides the count
// when everything would not fit. The decision uses natural widths only,
// which do not change when the count is hidden, so it cannot flip back and
// forth. Pure, so it is tested without the DOM.
export interface BarParts {
  /** The bar's inner width. */
  bar: number;
  /** The title's whole text, uncut (scrollWidth). */
  title: number;
  /** Everything else on the row that stays: back, the ending chip, More, the link, and the gaps between all the parts. */
  rest: number;
  /** The count's own width, as last measured while it was shown. */
  blunders: number;
}

/** True when the title and the count both fit on the row; false when the count must go. */
export function blundersFit(p: BarParts): boolean {
  if (p.bar <= 0) return true;
  return p.title + p.rest + p.blunders <= p.bar;
}
